import { render, staticRenderFns } from "./MenuInfo.vue?vue&type=template&id=b1edacc4&scoped=true"
import script from "./MenuInfo.vue?vue&type=script&lang=ts"
export * from "./MenuInfo.vue?vue&type=script&lang=ts"
import style0 from "./MenuInfo.vue?vue&type=style&index=0&id=b1edacc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1edacc4",
  null
  
)

export default component.exports